import { ControlBar, GraphicalOutputPlaceholder } from '@datacamp/campus-integration';
import { InstructionsPlaceholder } from '@datacamp/exercise-instruction-pane';
import { CollapseButton, CompletionPane } from '@datacamp/le-shared-components';
import ResizableElements, { CollapseContext } from '@datacamp/waffles-resizable-elements';
import * as React from 'react';
import { Translation } from 'react-i18next';
import LeftPanel from './LeftPanel';
import WorkbookFrame from './WorkbookFrame';
import { jsx as ___EmotionJSX } from "@emotion/react";
class ExerciseLayout extends React.Component {
  componentDidMount() {
    const {
      showExercise
    } = this.props;
    showExercise();
  }
  componentDidUpdate(_ref) {
    let {
      exercise: prevExercise
    } = _ref;
    const {
      exercise,
      showExercise
    } = this.props;
    if (exercise === undefined) {
      return;
    }
    if (prevExercise === undefined || prevExercise.id !== exercise.id) {
      showExercise();
    }
  }
  render() {
    const {
      completionPaneVisible,
      exercise,
      feedbackMessages,
      hideCompletionPane,
      instructions,
      interactionBlocked,
      onExerciseFinished,
      onRate,
      resetWorkbook,
      showHint,
      showSolution,
      solutionShown,
      submitExercise,
      successMessage,
      workbook,
      workbookReady,
      xpLost
    } = this.props;
    let hintCost = 0;
    let remainingXp = 0;
    if (exercise !== undefined) {
      hintCost = 0.3 * exercise.xp;
      remainingXp = exercise.xp - xpLost;
    }
    return ___EmotionJSX(ResizableElements, {
      collapsedSize: 38,
      initialProportions: [30, 70],
      orientation: "row"
    }, ___EmotionJSX(CollapseContext.Consumer, null, _ref2 => {
      let {
        collapsedFirstElement,
        toggleFirstElement
      } = _ref2;
      return (
        // eslint-disable-next-line no-nested-ternary
        collapsedFirstElement ? ___EmotionJSX(CollapseButton, {
          direction: "right",
          onClick: toggleFirstElement,
          style: {
            right: '0'
          }
        }) : exercise === undefined ? ___EmotionJSX(Translation, {
          ns: "glossary"
        }, t => ___EmotionJSX(InstructionsPlaceholder, {
          subHeadingText: t('exercise', {
            count: 1
          })
        })) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX(LeftPanel, {
          assignment: exercise.assignment,
          feedbackMessages: feedbackMessages,
          hintCost: hintCost,
          onClickCollapse: toggleFirstElement,
          onTakeHint: () => showHint({
            message: exercise.hint,
            xpCost: hintCost
          }),
          onTakeSolution: showSolution !== undefined ? () => showSolution(remainingXp) : undefined,
          solutionShown: solutionShown,
          title: exercise.title,
          xp: remainingXp
        }, instructions(exercise)), completionPaneVisible && ___EmotionJSX(CompletionPane, {
          message: successMessage,
          onClose: hideCompletionPane,
          onContinue: () => onExerciseFinished({
            id: exercise.id
          }),
          onRate: onRate,
          xp: remainingXp
        }))
      );
    }), ___EmotionJSX("div", {
      className: "dc-u-fx dc-u-fx-fdc dc-u-h-100pc"
    }, exercise === undefined || workbook === undefined ? ___EmotionJSX(GraphicalOutputPlaceholder, null) : ___EmotionJSX(WorkbookFrame, {
      key: exercise.workbookId,
      workbook: workbook
    }), submitExercise !== undefined && resetWorkbook !== undefined && ___EmotionJSX(ControlBar, {
      disabled: completionPaneVisible,
      loading: interactionBlocked || exercise === undefined || !workbookReady,
      onReset: resetWorkbook,
      onSubmit: submitExercise
    })));
  }
}
export default ExerciseLayout;